import { Directive } from '@angular/core';

@Directive({
  selector: '[appInputFormatDirective]'
})
export class InputFormatDirectiveDirective {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/directive/input-format-directive.directive.ts